import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} FotoMate. All rights reserved.</p>
      <div className="links">
        <a href="/contact">Contact</a>
        <a href="/faq">Help</a>
      </div>
    </footer>
  );
}
